document.addEventListener("DOMContentLoaded", () => {
  mobileFilterEvents();
});

function lockScrollBody() {
  const body = document.querySelector("body");
  if (body) {
    body.classList.add("lock-scroll");
  }
}

function unlockScrollBody() {
  const body = document.querySelector("body");
  if (body) {
    body.classList.remove("lock-scroll");
  }
}

function mobileFilterEvents() {
  closeMobileFilter();
  openMobileFilter();
}

// MOBILE FILTER OVERLAY
function closeMobileFilter() {
  const mobileFilterCloseButton = document.querySelectorAll(".mobile-filter__head-close");
  const mobileFIlterCloseOverlay = document.querySelector(".mobile-filter-close-overlay");
  if (mobileFilterCloseButton) {
    mobileFilterCloseButton.forEach((element) => {
      element.addEventListener("click", () => {
        const mobileFilterOverlay = document.querySelector(".mobile-filter-overlay");
        if (mobileFilterOverlay) {
          mobileFilterOverlay.classList.remove("open");
          unlockScrollBody();
        }
      });
    });
  }

  mobileFIlterCloseOverlay?.addEventListener("click", () => {
    const mobileFilterOverlay = document.querySelector(".mobile-filter-overlay");
    if (mobileFilterOverlay) {
      mobileFilterOverlay.classList.remove("open");
      unlockScrollBody();
    }
  });
}

// OPEN MOBILE FILTER
function openMobileFilter() {
  const mobileFilterOpenButton = document.getElementById("job-grid-filter-btn");
  if (mobileFilterOpenButton) {
    mobileFilterOpenButton.addEventListener("click", () => {
      const mobileFilterOverlay = document.querySelector(".mobile-filter-overlay");
      if (mobileFilterOverlay) {
        mobileFilterOverlay.classList.add("open");
        lockScrollBody();
      }
    });
  }
}
